import React from "react";
import { Container } from "react-bootstrap";

const SectionTitle = ({ title, question, description, date, end = false }) => {
  return (
    <Container fluid>
      <div className={"my-3"} style={{ maxWidth: "600px" }}>
        <h4 className="fw-semibold">{title}</h4>
        <p className={"open-sans"}>
          {question && !end && <b>{question} </b>}
          {description}
          {date && <b> {date}</b>}
          {question && end && <b> {question}</b>}
        </p>
      </div>
    </Container>
  );
};

export default SectionTitle;
